import { render } from "./GoToTop.vue?vue&type=template&id=478dc063&scoped=true&bindings={\"goToTop\":\"options\"}"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"

import "./GoToTop.vue?vue&type=style&index=0&id=478dc063&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-478dc063"

export default script